
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forums/ForumMessagePage/ForumMessagePage",
      function () {
        return require("private-next-pages/forums/ForumMessagePage/ForumMessagePage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forums/ForumMessagePage/ForumMessagePage"])
      });
    }
  